import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-12 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-90">
      <div className="max-w-2xl mx-auto text-center" data-id="element-91">
        <div className="mb-6" data-id="element-92">
          <span className="text-brand-tealLight font-bold text-xl flex items-center justify-center gap-2" data-id="element-93">
            <span data-id="element-94">🧪</span> BioKit Universitario™
          </span>
        </div>

        <p className="text-gray-400 text-sm mb-8 max-w-md mx-auto" data-id="element-95">
          El sistema N°1 de apuntes y organización para estudiantes de
          Bioquímica. Hecho por y para estudiantes como vos.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-gray-300 mb-8" data-id="element-96">
          <a href="mailto:contacto@biokit.com" className="hover:text-white transition-colors" data-id="element-97">
            📧 contacto@biokit.com
          </a>
          <span className="hidden sm:inline" data-id="element-98">·</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-99">
            📱 @biokit.uni
          </span>
          <span className="hidden sm:inline" data-id="element-100">·</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-101">
            🌐 biokit.com
          </span>
        </div>

        <div className="text-xs text-gray-500 space-y-2" data-id="element-102">
          <p data-id="element-103">© BioKit Universitario™ 2026 — Todos los derechos reservados.</p>
          <p className="italic" data-id="element-104">🧪 "Estudiá mejor. Entendé más. Aprobá."</p>
        </div>
      </div>
    </footer>;
}